shadow$provide[431] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 geometryScale;
attribute vec4 position4;

vec4 getRawPositionScale() {
  return geometryScale * position4;
}
`;

};